export default __webpack_public_path__ + "static/media/product-5.e43b4ebe.jpg";